import { useLogger } from "@agportal/logger";
import { createRestClient } from "@dmvs/client";
import { strict as assert } from "assert";
import { isEmpty, isNil } from "lodash-es";

export default class UlohyIsDtmkService {
    constructor(url) {
        assert(url, "url has to be specified");

        this.logger = useLogger();
        this.rest = createRestClient({
            baseURL: url,
        });
    }

    async vylistujUlohy(isDtmkId, query) {
        if (!isNil(isDtmkId) && !isEmpty(query)) {
            const { data } = await this.rest.post(`/by-isdtmk-id/${isDtmkId}/query`, query);

            this.logger.debug(
                "UlohyIsDtmkService.vylistujUlohy for isDtmkId {0} and query {1} returns {2}",
                isDtmkId,
                query,
                data
            );

            return data;
        }

        return null;
    }

    async ctiPozadavekByUuid(isDtmkId, uuid) {
        if (!isNil(isDtmkId) && !isNil(uuid)) {
            const { data } = await this.rest.get(`/by-isdtmk-id/${isDtmkId}/by-uuid/${uuid}`);

            this.logger.debug(
                "UlohyIsDtmkService.ctiPozadavekByUuid for isDtmkId {0} and uuid {1} returns {2}",
                isDtmkId,
                uuid,
                data
            );

            return data;
        }

        return null;
    }

    async vylistujSubjekty(query) {
        if (!isEmpty(query)) {
            const { data } = await this.rest.post("/subjekty/query", query);

            this.logger.debug("UlohyIsDtmkService.vylistujSubjekty for query {0} returns {1}", query, data);

            return data;
        }

        return null;
    }
}
